import React from "react";
import "./contactus.css";
import watsapp from "../../images/watsapp.png";

export default function Contactus() {
  return (
    <div className="contactus">
      <h2>Contact Us</h2>
      <div className="parentcont">
        <div className="lef">
          <h2>Call us on</h2>
          <h4>+254703570519</h4>

          <h2>Email Us</h2>
          <h4>lafemasystems@gmail.com</h4>

          <h2>Watsapp</h2>
          <a
            target="_blank"
            href="https://wa.me/+254703570519"
            rel="noreferrer"
          >
            <img src={watsapp} alt="watsapp" />
          </a>
        </div>

        <div className="kat">
          <h2>Topic:</h2>
          <input
            type="text"
            placeholder="Type topic here"
            className="clientupdateinput"
          />

          <h2>Message:</h2>
          <textarea
            rows={10}
            cols={5}
            placeholder="Type message here"
            className="clientmessageinput"
          />
        </div>
        <div className="mwish">
          <h2>Name:</h2>
          <input
            type="text"
            placeholder="Full Name"
            className="clientupdateinput2"
          />

          <h2>Email:</h2>
          <input
            type="text"
            placeholder="Email address"
            className="clientupdateinput2"
          />

          <h2>Phone Number:</h2>
          <input
            type="text"
            placeholder="Phone number"
            className="clientupdateinput2"
          />

          <h2>Address:</h2>
          <input
            type="text"
            placeholder="Mombasa"
            className="clientupdateinput2"
          />

          <button className="submit">submit</button>
        </div>
      </div>
      <div className="lowerspacer" />
    </div>
  );
}
